import { ChevronRight } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

const ROUTE_LABELS: Record<string, string> = {
  'app': 'Home',
  'dashboard': 'Dashboard',
  'models': 'Models',
  'predictions': 'Predictions',
  'data-sources': 'Data Sources',
  'settings': 'Settings',
  'history': 'History',
  'new': 'Create',
  'monitoring': 'Monitoring',
  'insights': 'Insights',
  'premium': 'Premium',
  'analytics': 'Insights',
  'profile': 'Profile',
  'billing': 'Billing',
  'team': 'Team',
  'integrations': 'Integrations',
  'api': 'API',
  'notifications': 'Notifications',
}

export function Breadcrumbs() {
  const location = useLocation()
  const pathSegments = location.pathname.split('/').filter(Boolean)

  // Build breadcrumb items
  const breadcrumbs = pathSegments.map((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/')
    // Check for label in ROUTE_LABELS, otherwise format the segment nicely
    const label = ROUTE_LABELS[segment] || formatSegment(segment)
    const isLast = index === pathSegments.length - 1

    return { path, label, isLast }
  })

  // Don't show breadcrumbs for root or single-level routes
  if (breadcrumbs.length <= 1) return null

  return (
    <nav aria-label="Breadcrumb" className="flex items-center text-sm text-muted-foreground">
      {breadcrumbs.map((crumb, i) => (
        <span key={crumb.path} className="flex items-center">
          {i > 0 && <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground/50" />}
          {crumb.isLast ? (
            <span className="font-medium text-foreground">{crumb.label}</span>
          ) : (
            <Link
              to={crumb.path}
              className="hover:text-foreground transition-colors"
            >
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  )
}

// Helper to format segments that aren't in ROUTE_LABELS
// Handles UUIDs, kebab-case, etc.
function formatSegment(segment: string): string {
  // Check if it's a UUID (don't try to format these nicely)
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)) {
    return 'Details'
  }

  // Convert kebab-case or snake_case to Title Case
  return segment
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
}
